import { motion } from "framer-motion";

const stats = [
  { number: "99%", label: "Customer Satisfaction" },
  { number: "2M+", label: "Active Users" },
  { number: "500+", label: "Enterprise Clients" },
  { number: "24/7", label: "Support Available" },
];

const Stats = () => {
  return (
    <section className="py-20 overflow-hidden">
      <div className="container px-4 mx-auto">
        <div className="flex flex-wrap -m-4">
          {stats.map((stat, index) => (
            <div key={index} className="w-full md:w-1/2 lg:w-1/4 p-4">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="relative inline-block">
                  <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/20 via-purple-500/20 to-pink-500/20 blur-xl rounded-full" />
                  <h3 className="relative text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
                    {stat.number}
                  </h3>
                </div>
                <p className="mt-4 text-gray-400 font-medium">{stat.label}</p>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
